<template>
	<div class="main-user">
		<navigations :path="path"></navigations>

		<img class="user-img" src="../assets/back-5.png" alt="">

		<div class="container-user">

			<div class="user-phone">
				<img src="../assets/phone.png" alt="">
			</div>

			<div class="user-qrcode">
				<div class="user-qrcode-box">
					<div class="user-qrcode-box-code">
						<img src="../assets/applet.jpg" alt="">
					</div>
					<div class="user-qrcode-box-content">
						<span class="user-qrcode-box-title">
							体验小程序
						</span>
						<span class="user-qrcode-box-text">
							即扫即用，方便快捷
						</span>
						<span class="user-qrcode-box-text">
							当天选货，可自提可配送
						</span>
						<span class="user-qrcode-box-text">
							海量红包，推广有奖
						</span>
					</div>
				</div>
				<div class="user-qrcode-box">
					<div class="user-qrcode-box-code">
						<img src="../assets/logo-3.png" alt="">
					</div>
					<div class="user-qrcode-box-content">
						<span class="user-qrcode-box-title">
							下载APP
						</span>
						<span class="user-qrcode-box-text">
							海量红包，尽在时购圈手机端
						</span>
						<span class="user-qrcode-box-text">
							一键社交，高级拼玩
						</span>
						<span class="user-qrcode-box-text">推广拓新享福利</span>
						<span class="user-qrcode-box-text">
							随机惊喜红包最高可达
							<span class="user-qrcode-box-blue">999元</span>
						</span>
					</div>
				</div>
			</div>

		</div>
		<tabbar></tabbar>
	</div>

</template>

<script>
	export default {
		name: 'user',
		props: {
			msg: String
		},
		data() {
			return {
				path: '/user'
			}
		},
		methods: {}
	}
</script>

<style>
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
		overflow: auto;
	}

	.main-user {
		width: 100%;
		height: 100%;
		padding-top: 100px;
		box-sizing: border-box;
	}

	.container-user {
		width: 100%;
		min-height: 100%;
		padding: 5% 15% 0 15%;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
	}

	.user-phone {
		width: 50%;
	}

	.user-qrcode {
		width: 50%;
		min-height: 200px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
	}

	.user-qrcode-box {
		width: 100%;
		height: 200px;
		box-sizing: border-box;
		padding: 30px;
		margin: 15px 0;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		border-radius: 30px;
		box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1);
	}

	.user-qrcode-box-code {
		width: 30%;
	}

	.user-qrcode-box-code img {
		width: 100%;
	}

	.user-qrcode-box-content {
		width: 70%;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: flex-start;
		align-items: flex-start;
		justify-content: center;
		padding-left: 15px;
		box-sizing: border-box;
		line-height: 30px;
	}

	.user-qrcode-box-title {
		font-size: 36px;
		color: #00BAAD;
		margin-bottom: 10px;
	}

	.user-qrcode-box-text {
		font-size: 21px;
		color: #757575;
	}

	.user-qrcode-box-blue {
		color: #00BAAD;
	}
	
	@media screen and (max-width: 768px) {
		.main-user {
			padding-top: 70px;
		}
		
		.container-user {
			padding: 15% 5% 0 5%;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
		}
		
		.user-phone {
		    width: 70%;
		}
		
		.user-phone img{
		    width: 100%;
		}
	
		.user-qrcode {
			width: 100%;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
			margin-top: 50px;
		}
	
		.user-qrcode-box {
			width: 80%;
			padding: 15px;
			margin: 15px 15px;
			height: 100px;
			border-radius: 10px;
		}
	
		.user-qrcode-box-title {
			font-size: 18px;
			margin-bottom: 10px;
		}
	
		.user-qrcode-box-text {
			font-size: 12px;
			text-align: left;
		}
		
		.user-img{
			width: 100%;
		}
		
		.user-qrcode-box-content {
		    width: 70%;
		    line-height: 15px;
		}
	}
</style>